// For a screen that refetches while its filters change: every request takes a ticket, and only the
// newest ticket may put its answer on screen. An older, slower answer arriving last is dropped.
export function createLatestGate() {
  let latest = 0;
  return {
    start: () => ++latest,
    isCurrent: (ticket) => ticket === latest,
  };
}
